import url from "/vercel/path0/src/assets/icons/ShippingBlack.svg?url";
export default url;
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShippingBlack = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_8910_102922",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_8910_102922)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.1396 9.43927L12.0021 8.51102L13.8646 9.43927V5.0719H10.1396V9.43927ZM6.8347 17.1676V14.9523H12.0021V17.1676H6.8347ZM5.07385 21.2034C4.44414 21.2034 3.90754 20.9817 3.46405 20.5382C3.02057 20.0947 2.79883 19.5581 2.79883 18.9284V5.0719C2.79883 4.44218 3.02057 3.90558 3.46405 3.4621C3.90754 3.01862 4.44414 2.79688 5.07385 2.79688H18.9304C19.5601 2.79688 20.0967 3.01862 20.5402 3.4621C20.9836 3.90558 21.2054 4.44218 21.2054 5.0719V18.9284C21.2054 19.5581 20.9836 20.0947 20.5402 20.5382C20.0967 20.9817 19.5601 21.2034 18.9304 21.2034H5.07385ZM5.07385 18.9284H18.9304V5.0719H16.0798V13.036L12.0021 11.0001L7.92438 13.036V5.0719H5.07385V18.9284Z",
				fill: "rgba(21, 32, 40, 1)"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgShippingBlack);
export { ForwardRef as ReactComponent };
